import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function contentListReducer(state = initialState.contentList, action) {
  let content = { ...state };

  switch (action.type) {
    case types.LOAD_CONTENT_LIST_SUCCESS:
      return action.res;

    case types.LOAD_MORE_CONTENT_LIST_SUCCESS: {
      const previousContent = content.data;
      content = action.res;
      content.data = [...previousContent, ...content.data];
      return content;
    }

    case types.DELETE_FROM_CONTENT_LIST_SUCCESS:
      content.data = content.data.filter(contentItem => contentItem.id !== action.contentId);
      return content;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./library/app/reducers/contentListReducer.js